import { z } from 'zod';

export const TEXT_MODEL_FLASH = 'deepseek-v4-flash' as const;
export const TEXT_MODEL_PRO = 'deepseek-v4-pro' as const;

export const TEXT_MODEL_IDS = [TEXT_MODEL_FLASH, TEXT_MODEL_PRO] as const;
export type TextModelId = (typeof TEXT_MODEL_IDS)[number];

export const DEFAULT_TEXT_MODEL: TextModelId = TEXT_MODEL_FLASH;
export const textModelSchema = z.enum(TEXT_MODEL_IDS);

export const TEXT_MODEL_OPTIONS = [
  {
    id: TEXT_MODEL_FLASH,
    label: 'DeepSeek V4 Flash',
    description: '速度优先 · 成本较低',
  },
  {
    id: TEXT_MODEL_PRO,
    label: 'DeepSeek V4 Pro',
    description: '质量优先 · 成本约为 Flash 的 3 倍',
  },
] as const;

export function isTextModelId(value: unknown): value is TextModelId {
  return typeof value === 'string' && (TEXT_MODEL_IDS as readonly string[]).includes(value);
}
